export const breakpoints = {
  xs: '100px',
  s: '165px',
  sm: '245px',
  mm: '415px',
  md: '540px',
  lg: '750px',
  ll: '844px',
  xl: '975px',
  xxl: '1005px',
  xxxl: '1424px',
};




export const devices = {
  xs: `(min-width: ${breakpoints.xs})`,
  sm: `(min-width: ${breakpoints.sm})`,
  mm: `(min-width: ${breakpoints.mm})`,
  md: `(min-width: ${breakpoints.md})`,
  lg: `(min-width: ${breakpoints.lg})`,
  ll: `(min-width: ${breakpoints.ll})`,
  xl: `(min-width: ${breakpoints.xl})`,
  xxl: `(min-width: ${breakpoints.xxl})`,
  xxxl: `(min-width: ${breakpoints.xxxl})`,
};
